module.exports = __webpack_public_path__ + "static/media/7pielegnacja.e28b8e3a.png";